// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.token-page {
    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;
    background-color: #FFFFFF;
    color: #111827;
    padding: 40px 0 0px 0;
    position: relative;
    overflow: hidden;
}

.token-container {
    max-width: 1480px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
}

.gold-text {
    color: #D3B06C;
}

.token-hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    padding: 90px 0px;
    position: relative;
}

.token-hero-left {
    flex: 1 1;
    max-width: 720px;
}

.token-hero-title {
    font-size: 58px;
    font-weight: 700;
    color: #111827;
    line-height: 1.15;
    margin: 0 0 18px 0;
    letter-spacing: -0.5px;
}

.token-hero-desc {
    max-width: 70%;
    font-size: 16px;
    color: #6B7280;
    line-height: 1.6;
    margin: 0 0 28px 0;
}

.token-hero-btns {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
}

.token-hero-btns a {
    font-size: 15px;
    border-radius: 50px;
    gap: 6px;
    padding: 12px 28px;
}

.token-hero .buybtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #D3B06C;
    color: #FFFFFF;
    font-weight: 700;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);
    transition: all 0.25s ease;
    text-decoration: none;
}

.token-hero .buybtn:hover {
    background-color: #C09D5B;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.35);
    color: #FFFFFF;
}

.whitepaperbtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #EFEFEF;
    color: #374151;
    font-weight: 600;
    border: 1px solid #E2E8F0;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
}

.whitepaperbtn:hover {
    background-color: #F1F5F9;
    color: #111827;
}

.contract-address-box {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: #6B7280;
    background-color: #FAFAFA;
    padding: 8px 16px;
    border-radius: 50px;
    border: 1px solid #F3F4F6;
}

.contract-code {
    font-family: monospace;
    font-weight: 600;
    color: #111827;
}

.copy-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    color: #D3B06C;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
}

.token-hero-right {
    position: relative;
    width: 620px;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.token-hero-right img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}

.floating-pill {
    position: absolute;
    padding: 6px 16px;
    background-color: #FFFFFF;
    border: 1px solid #E5E7EB;
    border-radius: 50px;
    font-size: 12px;
    font-weight: 600;
    color: #374151;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.floating-pill.top-right {
    top: 40px;
    right: 40px;
}

.floating-pill.middle-left {
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
}



.token-metrics-bar {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    border-radius: 0px;
    text-align: center;
}

.tokenlist_value {
    width: 100%;
    background-color: #ffffff0f;
    border: 1px solid #ffffff0f;
    padding: 16px 0px;
    margin-bottom: 90px;
}

body.light_theme .tokenlist_value {
    background-color: #F9FAFB;
    border: 1px solid #F3F4F6;
}

.metric-stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.metric-stat-value {
    font-size: 16px;
    font-weight: 800;
    color: #eeeeee;
    line-height: 1.2;
    margin-bottom: 2px;
}

body.light_theme .metric-stat-value {
    color: #111827;
}

.metric-stat-label {
    font-size: 12px;
    color: #9CA3AF;
    font-weight: 400;
}

span.sub-label {
    font-size: 12px;
    color: #D1AA67;
    font-weight: 500;
}



.why-agce-section {
    margin-bottom: 100px;
    position: relative;
}

.section-header-center {
    text-align: center;
    margin-bottom: 60px;
}

.section-header-center h2 {
    font-size: 42px;
    font-weight: 700;
    color: #111827;
    margin: 0;
}

.diamond-flow-wrapper {
    position: relative;
    max-width: 100%;
    margin: 0 auto;
    padding: 20px 0;
}

.why-agce-bg-vector {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 1240px;
    height: auto;
    pointer-events: none;
    z-index: 0;
}

.diamond-flow-container {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 0px;
    position: relative;
    z-index: 1;
    height: 274px;
}

.diamond-col {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.diamond-col.is-top {
    justify-content: flex-start;
}

.diamond-col.is-bottom {
    justify-content: space-between;
    padding-top: 85px;
    /* flex-direction: column-reverse; */
    height: 200px;
}

.diamond-icon-box {
    width: 48px;
    left: -4px;
    height: 48px;
    background-color: #D1AA67;
    transform: rotate(45deg);
    border-radius: 0px;
    position: relative;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 26px 0px;
    box-shadow: 0 6px 16px rgba(211, 176, 108, 0.35);
    flex-shrink: 0;
}

.diamond-icon-box img {
    transform: rotate(-45deg);
    width: 26px;
    height: 26px;
    object-fit: contain;
}

.diamond-text-content {
    max-width: 160px;
    position: relative;
    z-index: 999;
}

.diamond-text-content h3 {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 6px 0;
    line-height: 1.25;
}

body.light_theme .diamond-text-content h3 {
    color: #111827;
}

.diamond-text-content p {
    font-size: 11px;
    color: #efefef;
    line-height: 1.45;
    margin: 0;
}

body.light_theme .diamond-text-content p {
    color: #6B7280;
}

.tokenomics-grid-section {
    margin-bottom: 90px;
}

.token-cards-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-bottom: 24px;
}

.token-card {
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
    border-radius: 20px;
    padding: 24px;
    box-shadow: 0 0px 5px rgb(0 0 0 / 11%);
}

.token_mid_p {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.token-card-title {
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 15px 0;
}

/* Card 1: Price Chart */
.price-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.price-value-box {
    display: flex;
    align-items: center;
    gap: 12px;
}

.price-main {
    font-size: 32px;
    font-weight: 800;
    color: #f5f5f5;
}

body.light_theme .price-main {
    color: #111827;
}

.badge-positive {
    padding: 4px 10px;
    background-color: #ECFDF5;
    color: #10B981;
    font-size: 12px;
    font-weight: 700;
    border-radius: 50px;
}

.time-filters {
    display: flex;
    gap: 6px;
}

.filter-btn {
    padding: 4px 10px;
    border-radius: 6px;
    border: none;
    background-color: #F3F4F6;
    font-size: 12px;
    font-weight: 600;
    color: #6B7280;
    cursor: pointer;
}

.filter-btn.active {
    background-color: #D3B06C;
    color: #FFFFFF;
}

.chart-bars-mock {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    height: 350px;
    padding: 20px 0 10px 0;
    border-bottom: 1px solid #F3F4F6;
    margin-bottom: 12px;
}

.chart-bar {
    width: 34px;
    background-color: #F3E8D2;
    border-radius: 8px 8px 0 0;
    transition: height 0.3s ease;
}

.chart-bar.highlight {
    background-color: #D3B06C;
}

.chart-footer-note {
    font-size: 12px;
    color: #9CA3AF;
    margin: 0;
}

/* Card 2: Benefits & Circulation */
.benefits-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 0px;
}

.benefit-item-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.benefit-icon-badge {
    width: 36px;
    height: 36px;
    border-radius: 11px;
    background-color: #FFF0D8;
    display: flex;
    align-items: center;
    justify-content: center;
}

.benefit-icon-badge img {
    width: 18px;
    height: 18px;
    object-fit: contain;
}

.benefit-item-text h4 {
    font-size: 14px;
    font-weight: 700;
    color: #efefef;
    margin: 0 0 2px 0;
}

body.light_theme .benefit-item-text h4 {
    color: #111827;
}

.benefit-item-text p {
    font-size: 13px;
    color: #b9b9b9;
    margin: 0;
    line-height: 1.4;
}

body.light_theme .benefit-item-text p {
    color: #6B7280;
}

.circulation-bars {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.circ-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
}

.circ-label {
    color: #dadada;
    font-weight: 600;
    width: 90px;
}

body.light_theme .circ-label {
    color: #4B5563;
}

.circ-bar-bg {
    flex: 1 1;
    height: 6px;
    background-color: #F3F4F6;
    border-radius: 10px;
    margin: 0 12px;
    overflow: hidden;
}

.circ-bar-fill {
    height: 100%;
    border-radius: 10px;
}

.circ-val {
    font-weight: 700;
    color: #f3f3f3;
    width: 30px;
    text-align: right;
}

body.light_theme .circ-val {
    color: #111827;
}

.circ-bar-fill.public-sale {
    background-color: #F97316;
}

.circ-bar-fill.ecosystem {
    background-color: #10B981;
}

.circ-bar-fill.team {
    background-color: #3B82F6;
}

.circ-bar-fill.reserve {
    background-color: #8B5CF6;
}

.circ-bar-fill.marketing {
    background-color: #EC4899;
}

/* Card 3: Use Cases */
.usecases-list {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.usecase-item {
    display: flex;
    align-items: flex-start;
    gap: 14px;
}

.usecase-icon-box {
    width: 42px;
    height: 42px;
    border-radius: 14px;
    background-color: #FFF0D8;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.usecase-icon-box img {
    width: 18px;
    height: 18px;
    object-fit: contain;
}

.usecase-text h4 {
    font-size: 13px;
    font-weight: 600;
    color: #f5f5f5;
    margin: 0 0 4px 0;
}

body.light_theme .usecase-text h4 {
    color: #111827;
}

.usecase-text p {
    font-size: 12px;
    color: #99A1AF;
    margin: 0;
    line-height: 1.4;
}

/* Bottom Grid Row: Interoperability & Roadmap */
.bottom-cards-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
}

.chains-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 24px;
}

.chain-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 5px 14px 5px 5px;
    background-color: #FFFFFF;
    border: 1px solid #E5E7EB;
    border-radius: 12px;
    transition: all 0.2s ease;
}

.chain-circle {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    font-weight: 800;
    color: #FFFFFF;
    flex-shrink: 0;
    letter-spacing: 0.2px;
}

.chain-circle.eth {
    background-color: #4F59E7;
}

.chain-circle.bnb {
    background-color: #EAB308;
}

.chain-circle.pol {
    background-color: #8B5CF6;
}

.chain-circle.ava {
    background-color: #EF4444;
}

.chain-circle.sol {
    background-color: #A855F7;
}

.chain-circle.arb {
    background-color: #0EA5E9;
}

.chain-name {
    font-size: 13px;
    font-weight: 700;
    color: #374151;
}

.interop-link {
    font-size: 13px;
    font-weight: 600;
    color: #D3B06C;
    text-decoration: none;
    display: inline-block;
    margin-top: 10px;
    transition: color 0.2s ease;
}

.interop-link:hover {
    color: #C09D5B;
}

.roadmap-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.roadmap-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.roadmap-left {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.roadmap-icon {
    font-size: 20px;
    margin-top: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.roadmap-icon.done {
    color: #D3B06C;
}

.roadmap-icon.soon {
    color: #D1D5DB;
}

.roadmap-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.roadmap-quarter {
    font-size: 13px;
    font-weight: 700;
    display: block;
}

.roadmap-quarter.done {
    color: #D3B06C;
}

.roadmap-quarter.soon {
    color: #9CA3AF;
    font-weight: 600;
}

.roadmap-title {
    font-size: 14px;
    font-weight: 500;
    color: #d2d2d2;
}

body.light_theme .roadmap-title {
    color: #4B5563;
}

.roadmap-status-badge {
    padding: 4px 14px;
    border-radius: 50px;
    font-size: 12px;
    font-weight: 600;
}

.roadmap-status-badge.done {
    background-color: #FEF3C7;
    color: #D97706;
}

.roadmap-status-badge.soon {
    background-color: #F3F4F6;
    color: #9CA3AF;
}


.news-section {
    margin-bottom: 0px;
    background-color: #F9FAFB;
    padding: 48px 0px;
}

.news-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
}

.news-card {
    background-color: #181a20;
    border: 1px solid #eaf0fd1a;
    border-radius: 20px;
    padding: 24px;
    box-shadow: 0 0px 3px rgb(0 0 0 / 11%);
    position: relative;
    overflow: hidden;
    transition: transform 0.25s ease;
}

body.light_theme .news-card {
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
}

.news-card:hover {
    transform: translateY(-4px);
}

.news-card-top-border {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 7px;
}

.news-card-top-border.purple {
    background-color: #8B5CF6;
}

.news-card-top-border.green {
    background-color: #10B981;
}

.news-card-top-border.gold {
    background-color: #F59E0B;
}

.news-category-badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 12px;
}

.news-category-badge.purple {
    background-color: #F5F3FF;
    color: #8B5CF6;
}

.news-category-badge.green {
    background-color: #ECFDF5;
    display: inline-block;
    color: #10B981;
}

.news-category-badge.gold {
    background-color: #FFFBEB;
    color: #F59E0B;
}

.news-card h3 {
    font-size: 15px;
    font-weight: 700;
    color: #f8f8f8;
    margin: 0 0 12px 0;
    line-height: 1.4;
}

body.light_theme .news-card h3 {
    color: #111827;
}

.news-date {
    font-size: 12px;
    color: #9CA3AF;
}



@media (max-width: 1500px) {

    .token-container {
        max-width: 95%;
    }

    .diamond-col.is-bottom {
        padding-top: 95px;
    }

    .token-hero-title {
        font-size: 48px;
    }

}


@media (max-width: 1200px) {



    .token-hero-title {
        font-size: 38px;
    }

    .token-hero-right {
        width: 400px;
    }

    .token-hero {
        padding: 40px 0px;
    }

    /* .diamond-flow-container {
        grid-template-columns: repeat(3, 1fr);
        height: auto;
        gap: 30px;
    } */

    .diamond-col.is-bottom {
        padding-top: 120px;
    }

    .section-header-center h2 {
        font-size: 36px;
    }

    .chart-bar {
        width: 26px;
    }

    .bottom-cards-grid {
        grid-template-columns: 1fr;
    }

    .news-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 991px) {

    .token-hero-right {
        width: 340px;
    }

    .diamond-text-content h3 {
        color: #fff;
    }

    body.light_theme .diamond-text-content h3 {
        color: #111827;
    }

    .token-hero-title {
        font-size: 32px;
    }

    .token-hero-desc {
        max-width: 100%;
        font-size: 15px;
        margin: 0 0 22px 0;
    }

    .token-hero-btns a {
        font-size: 14px;
        padding: 10px 22px;
    }

    .diamond-flow-container {
        grid-template-columns: repeat(3, 1fr);
    }

    .token-hero {
        padding: 20px 0px 40px;
    }

    .tokenlist_value {
        margin-bottom: 40px;
    }

    .section-header-center h2 {
        font-size: 32px;
    }

    .why-agce-bg-vector {
        display: none;
    }

    .diamond-col.is-bottom {
        flex-direction: column-reverse;
        padding-top: 0px;
        justify-content: start;
    }

    .diamond-flow-container {
        height: 100%;
    }

    .section-header-center {
        margin-bottom: 10px;
    }

    .why-agce-section {
        margin-bottom: 10px;
    }

    .token-cards-grid {
        grid-template-columns: repeat(1, 1fr);
    }

    .tokenomics-grid-section {
        margin-bottom: 40px;
    }


}

@media (max-width: 767px) {


    .token-hero {
        padding: 10px 0px 20px;
        flex-direction: column;
        text-align: center;
        gap: 20px;
    }

    .token-hero-btns {
        justify-content: center;
        margin-bottom: 20px;
    }

    .token-hero-title {
        font-size: 26px;
        margin-bottom: 12px;
    }

    .token-hero-desc {
        font-size: 14px;
        margin: 0px 0 15px 0;
    }

    .token-metrics-bar {
        grid-template-columns: repeat(3, 1fr);
        gap: 15px;
    }

    .tokenlist_value {
        margin-bottom: 30px;
    }

    .section-header-center h2 {
        font-size: 24px;
    }


}

@media (max-width: 580px) {

    .token-metrics-bar {
        grid-template-columns: repeat(2, 1fr);
    }

    .diamond-flow-container {
        grid-template-columns: repeat(2, 1fr);
    }

    .diamond-col.is-bottom {
        height: 180px;
    }

    .price-main {
        font-size: 24px;
    }

    .token-card-title {
        font-size: 18px;
    }

    .token-card {
        padding: 20px;
    }

    .benefit-icon-badge {
        width: 32px;
        min-width: 32px;
        height: 32px;
    }

    .news-section h2.token-card-title {
        font-size: 22px !important;
        margin-bottom: 12px !important;
    }

    .news-section {
        padding: 30px 0px;
    }

}

/* fix kero - Dark theme support for Token page */
html[data-theme="dark"] .token-page,
body:not(.light_theme) .token-page {
    background-color: #0b0e14;
    color: #ffffff;
}

html[data-theme="dark"] .token-hero-title,
html[data-theme="dark"] .section-header-center h2,
html[data-theme="dark"] .token-card-title,
html[data-theme="dark"] .metric-value,
html[data-theme="dark"] .contract-code,
html[data-theme="dark"] .use-case-title,
html[data-theme="dark"] .benefit-title,
body:not(.light_theme) .token-hero-title,
body:not(.light_theme) .section-header-center h2,
body:not(.light_theme) .token-card-title,
body:not(.light_theme) .metric-value,
body:not(.light_theme) .contract-code,
body:not(.light_theme) .use-case-title,
body:not(.light_theme) .benefit-title {
    color: #ffffff;
}

html[data-theme="dark"] .token-hero-desc,
html[data-theme="dark"] .section-header-center p,
html[data-theme="dark"] .token-card-desc,
html[data-theme="dark"] .metric-item h4,
html[data-theme="dark"] .metric-item p,
html[data-theme="dark"] .use-case-desc,
html[data-theme="dark"] .contract-address-box,
body:not(.light_theme) .token-hero-desc,
body:not(.light_theme) .section-header-center p,
body:not(.light_theme) .token-card-desc,
body:not(.light_theme) .metric-item h4,
body:not(.light_theme) .metric-item p,
body:not(.light_theme) .use-case-desc,
body:not(.light_theme) .contract-address-box {
    color: #a0aab5;
}


html[data-theme="dark"] .token-card,
html[data-theme="dark"] .use-case-card,
html[data-theme="dark"] .benefit-card,
body:not(.light_theme) .token-card,
body:not(.light_theme) .use-case-card,
body:not(.light_theme) .benefit-card {
    background-color: #181a20;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    border: 1px solid #2b3139;
}

html[data-theme="dark"] .use-cases-section,
html[data-theme="dark"] .news-section,
body:not(.light_theme) .use-cases-section,
body:not(.light_theme) .news-section {
    background-color: #0b0e14;
}

html[data-theme="dark"] .whitepaperbtn,
body:not(.light_theme) .whitepaperbtn {
    background-color: #2b3139;
    color: #ffffff;
    border-color: #3b424a;
}

html[data-theme="dark"] .whitepaperbtn:hover,
body:not(.light_theme) .whitepaperbtn:hover {
    background-color: #3b424a;
    color: #ffffff;
}

html[data-theme="dark"] .contract-address-box,
body:not(.light_theme) .contract-address-box {
    background-color: #181a20;
    border-color: #2b3139;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TokenPage/token-premium.css"],"names":[],"mappings":"AAAA;IACI,oEAAoE;IACpE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gDAAgD;IAChD,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,2BAA2B;AAC/B;;;;AAIA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;;;AAIA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA,gDAAgD;AAChD;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;;;AAIA;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;AAGA;;;;IAII;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;;;OAIG;;IAEH;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;QAC9B,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,mBAAmB;IACvB;;;AAGJ;;AAEA;;;IAGI;QACI,sBAAsB;QACtB,sBAAsB;QACtB,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;;AAGJ;;AAEA;;IAEI;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;IACrB;;AAEJ;;AAEA,iDAAiD;AACjD;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;;;;;;;;;;;IAcI,cAAc;AAClB;;AAEA;;;;;;;;;;;;;;IAcI,cAAc;AAClB;;;AAGA;;;;;;IAMI,yBAAyB;IACzB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":[".token-page {\n    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;\n    background-color: #FFFFFF;\n    color: #111827;\n    padding: 40px 0 0px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n.token-container {\n    max-width: 1480px;\n    margin: 0 auto;\n    padding: 0 20px;\n    position: relative;\n    z-index: 1;\n}\n\n.gold-text {\n    color: #D3B06C;\n}\n\n.token-hero {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 40px;\n    padding: 90px 0px;\n    position: relative;\n}\n\n.token-hero-left {\n    flex: 1;\n    max-width: 720px;\n}\n\n.token-hero-title {\n    font-size: 58px;\n    font-weight: 700;\n    color: #111827;\n    line-height: 1.15;\n    margin: 0 0 18px 0;\n    letter-spacing: -0.5px;\n}\n\n.token-hero-desc {\n    max-width: 70%;\n    font-size: 16px;\n    color: #6B7280;\n    line-height: 1.6;\n    margin: 0 0 28px 0;\n}\n\n.token-hero-btns {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.token-hero-btns a {\n    font-size: 15px;\n    border-radius: 50px;\n    gap: 6px;\n    padding: 12px 28px;\n}\n\n.token-hero .buybtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #D3B06C;\n    color: #FFFFFF;\n    font-weight: 700;\n    border: none;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);\n    transition: all 0.25s ease;\n    text-decoration: none;\n}\n\n.token-hero .buybtn:hover {\n    background-color: #C09D5B;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.35);\n    color: #FFFFFF;\n}\n\n.whitepaperbtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #EFEFEF;\n    color: #374151;\n    font-weight: 600;\n    border: 1px solid #E2E8F0;\n    border-radius: 50px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-decoration: none;\n}\n\n.whitepaperbtn:hover {\n    background-color: #F1F5F9;\n    color: #111827;\n}\n\n.contract-address-box {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 13px;\n    color: #6B7280;\n    background-color: #FAFAFA;\n    padding: 8px 16px;\n    border-radius: 50px;\n    border: 1px solid #F3F4F6;\n}\n\n.contract-code {\n    font-family: monospace;\n    font-weight: 600;\n    color: #111827;\n}\n\n.copy-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    background: none;\n    border: none;\n    color: #D3B06C;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 0;\n}\n\n.token-hero-right {\n    position: relative;\n    width: 620px;\n    max-width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.token-hero-right img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n.floating-pill {\n    position: absolute;\n    padding: 6px 16px;\n    background-color: #FFFFFF;\n    border: 1px solid #E5E7EB;\n    border-radius: 50px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #374151;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n}\n\n.floating-pill.top-right {\n    top: 40px;\n    right: 40px;\n}\n\n.floating-pill.middle-left {\n    top: 50%;\n    left: 20px;\n    transform: translateY(-50%);\n}\n\n\n\n.token-metrics-bar {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 20px;\n    border-radius: 0px;\n    text-align: center;\n}\n\n.tokenlist_value {\n    width: 100%;\n    background-color: #ffffff0f;\n    border: 1px solid #ffffff0f;\n    padding: 16px 0px;\n    margin-bottom: 90px;\n}\n\nbody.light_theme .tokenlist_value {\n    background-color: #F9FAFB;\n    border: 1px solid #F3F4F6;\n}\n\n.metric-stat-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.metric-stat-value {\n    font-size: 16px;\n    font-weight: 800;\n    color: #eeeeee;\n    line-height: 1.2;\n    margin-bottom: 2px;\n}\n\nbody.light_theme .metric-stat-value {\n    color: #111827;\n}\n\n.metric-stat-label {\n    font-size: 12px;\n    color: #9CA3AF;\n    font-weight: 400;\n}\n\nspan.sub-label {\n    font-size: 12px;\n    color: #D1AA67;\n    font-weight: 500;\n}\n\n\n\n.why-agce-section {\n    margin-bottom: 100px;\n    position: relative;\n}\n\n.section-header-center {\n    text-align: center;\n    margin-bottom: 60px;\n}\n\n.section-header-center h2 {\n    font-size: 42px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0;\n}\n\n.diamond-flow-wrapper {\n    position: relative;\n    max-width: 100%;\n    margin: 0 auto;\n    padding: 20px 0;\n}\n\n.why-agce-bg-vector {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    max-width: 1240px;\n    height: auto;\n    pointer-events: none;\n    z-index: 0;\n}\n\n.diamond-flow-container {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    gap: 0px;\n    position: relative;\n    z-index: 1;\n    height: 274px;\n}\n\n.diamond-col {\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.diamond-col.is-top {\n    justify-content: flex-start;\n}\n\n.diamond-col.is-bottom {\n    justify-content: space-between;\n    padding-top: 85px;\n    /* flex-direction: column-reverse; */\n    height: 200px;\n}\n\n.diamond-icon-box {\n    width: 48px;\n    left: -4px;\n    height: 48px;\n    background-color: #D1AA67;\n    transform: rotate(45deg);\n    border-radius: 0px;\n    position: relative;\n    z-index: 999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 26px 0px;\n    box-shadow: 0 6px 16px rgba(211, 176, 108, 0.35);\n    flex-shrink: 0;\n}\n\n.diamond-icon-box img {\n    transform: rotate(-45deg);\n    width: 26px;\n    height: 26px;\n    object-fit: contain;\n}\n\n.diamond-text-content {\n    max-width: 160px;\n    position: relative;\n    z-index: 999;\n}\n\n.diamond-text-content h3 {\n    font-size: 14px;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 6px 0;\n    line-height: 1.25;\n}\n\nbody.light_theme .diamond-text-content h3 {\n    color: #111827;\n}\n\n.diamond-text-content p {\n    font-size: 11px;\n    color: #efefef;\n    line-height: 1.45;\n    margin: 0;\n}\n\nbody.light_theme .diamond-text-content p {\n    color: #6B7280;\n}\n\n.tokenomics-grid-section {\n    margin-bottom: 90px;\n}\n\n.token-cards-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    margin-bottom: 24px;\n}\n\n.token-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n    border-radius: 20px;\n    padding: 24px;\n    box-shadow: 0 0px 5px rgb(0 0 0 / 11%);\n}\n\n.token_mid_p {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.token-card-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: #111827;\n    margin: 0 0 15px 0;\n}\n\n/* Card 1: Price Chart */\n.price-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.price-value-box {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.price-main {\n    font-size: 32px;\n    font-weight: 800;\n    color: #f5f5f5;\n}\n\nbody.light_theme .price-main {\n    color: #111827;\n}\n\n.badge-positive {\n    padding: 4px 10px;\n    background-color: #ECFDF5;\n    color: #10B981;\n    font-size: 12px;\n    font-weight: 700;\n    border-radius: 50px;\n}\n\n.time-filters {\n    display: flex;\n    gap: 6px;\n}\n\n.filter-btn {\n    padding: 4px 10px;\n    border-radius: 6px;\n    border: none;\n    background-color: #F3F4F6;\n    font-size: 12px;\n    font-weight: 600;\n    color: #6B7280;\n    cursor: pointer;\n}\n\n.filter-btn.active {\n    background-color: #D3B06C;\n    color: #FFFFFF;\n}\n\n.chart-bars-mock {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    height: 350px;\n    padding: 20px 0 10px 0;\n    border-bottom: 1px solid #F3F4F6;\n    margin-bottom: 12px;\n}\n\n.chart-bar {\n    width: 34px;\n    background-color: #F3E8D2;\n    border-radius: 8px 8px 0 0;\n    transition: height 0.3s ease;\n}\n\n.chart-bar.highlight {\n    background-color: #D3B06C;\n}\n\n.chart-footer-note {\n    font-size: 12px;\n    color: #9CA3AF;\n    margin: 0;\n}\n\n/* Card 2: Benefits & Circulation */\n.benefits-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 0px;\n}\n\n.benefit-item-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.benefit-icon-badge {\n    width: 36px;\n    height: 36px;\n    border-radius: 11px;\n    background-color: #FFF0D8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.benefit-icon-badge img {\n    width: 18px;\n    height: 18px;\n    object-fit: contain;\n}\n\n.benefit-item-text h4 {\n    font-size: 14px;\n    font-weight: 700;\n    color: #efefef;\n    margin: 0 0 2px 0;\n}\n\nbody.light_theme .benefit-item-text h4 {\n    color: #111827;\n}\n\n.benefit-item-text p {\n    font-size: 13px;\n    color: #b9b9b9;\n    margin: 0;\n    line-height: 1.4;\n}\n\nbody.light_theme .benefit-item-text p {\n    color: #6B7280;\n}\n\n.circulation-bars {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.circ-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 12px;\n}\n\n.circ-label {\n    color: #dadada;\n    font-weight: 600;\n    width: 90px;\n}\n\nbody.light_theme .circ-label {\n    color: #4B5563;\n}\n\n.circ-bar-bg {\n    flex: 1;\n    height: 6px;\n    background-color: #F3F4F6;\n    border-radius: 10px;\n    margin: 0 12px;\n    overflow: hidden;\n}\n\n.circ-bar-fill {\n    height: 100%;\n    border-radius: 10px;\n}\n\n.circ-val {\n    font-weight: 700;\n    color: #f3f3f3;\n    width: 30px;\n    text-align: right;\n}\n\nbody.light_theme .circ-val {\n    color: #111827;\n}\n\n.circ-bar-fill.public-sale {\n    background-color: #F97316;\n}\n\n.circ-bar-fill.ecosystem {\n    background-color: #10B981;\n}\n\n.circ-bar-fill.team {\n    background-color: #3B82F6;\n}\n\n.circ-bar-fill.reserve {\n    background-color: #8B5CF6;\n}\n\n.circ-bar-fill.marketing {\n    background-color: #EC4899;\n}\n\n/* Card 3: Use Cases */\n.usecases-list {\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n}\n\n.usecase-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n}\n\n.usecase-icon-box {\n    width: 42px;\n    height: 42px;\n    border-radius: 14px;\n    background-color: #FFF0D8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.usecase-icon-box img {\n    width: 18px;\n    height: 18px;\n    object-fit: contain;\n}\n\n.usecase-text h4 {\n    font-size: 13px;\n    font-weight: 600;\n    color: #f5f5f5;\n    margin: 0 0 4px 0;\n}\n\nbody.light_theme .usecase-text h4 {\n    color: #111827;\n}\n\n.usecase-text p {\n    font-size: 12px;\n    color: #99A1AF;\n    margin: 0;\n    line-height: 1.4;\n}\n\n/* Bottom Grid Row: Interoperability & Roadmap */\n.bottom-cards-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n}\n\n.chains-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n    margin-bottom: 24px;\n}\n\n.chain-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 5px 14px 5px 5px;\n    background-color: #FFFFFF;\n    border: 1px solid #E5E7EB;\n    border-radius: 12px;\n    transition: all 0.2s ease;\n}\n\n.chain-circle {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 9px;\n    font-weight: 800;\n    color: #FFFFFF;\n    flex-shrink: 0;\n    letter-spacing: 0.2px;\n}\n\n.chain-circle.eth {\n    background-color: #4F59E7;\n}\n\n.chain-circle.bnb {\n    background-color: #EAB308;\n}\n\n.chain-circle.pol {\n    background-color: #8B5CF6;\n}\n\n.chain-circle.ava {\n    background-color: #EF4444;\n}\n\n.chain-circle.sol {\n    background-color: #A855F7;\n}\n\n.chain-circle.arb {\n    background-color: #0EA5E9;\n}\n\n.chain-name {\n    font-size: 13px;\n    font-weight: 700;\n    color: #374151;\n}\n\n.interop-link {\n    font-size: 13px;\n    font-weight: 600;\n    color: #D3B06C;\n    text-decoration: none;\n    display: inline-block;\n    margin-top: 10px;\n    transition: color 0.2s ease;\n}\n\n.interop-link:hover {\n    color: #C09D5B;\n}\n\n.roadmap-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.roadmap-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.roadmap-left {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.roadmap-icon {\n    font-size: 20px;\n    margin-top: 1px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.roadmap-icon.done {\n    color: #D3B06C;\n}\n\n.roadmap-icon.soon {\n    color: #D1D5DB;\n}\n\n.roadmap-text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.roadmap-quarter {\n    font-size: 13px;\n    font-weight: 700;\n    display: block;\n}\n\n.roadmap-quarter.done {\n    color: #D3B06C;\n}\n\n.roadmap-quarter.soon {\n    color: #9CA3AF;\n    font-weight: 600;\n}\n\n.roadmap-title {\n    font-size: 14px;\n    font-weight: 500;\n    color: #d2d2d2;\n}\n\nbody.light_theme .roadmap-title {\n    color: #4B5563;\n}\n\n.roadmap-status-badge {\n    padding: 4px 14px;\n    border-radius: 50px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.roadmap-status-badge.done {\n    background-color: #FEF3C7;\n    color: #D97706;\n}\n\n.roadmap-status-badge.soon {\n    background-color: #F3F4F6;\n    color: #9CA3AF;\n}\n\n\n.news-section {\n    margin-bottom: 0px;\n    background-color: #F9FAFB;\n    padding: 48px 0px;\n}\n\n.news-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n}\n\n.news-card {\n    background-color: #181a20;\n    border: 1px solid #eaf0fd1a;\n    border-radius: 20px;\n    padding: 24px;\n    box-shadow: 0 0px 3px rgb(0 0 0 / 11%);\n    position: relative;\n    overflow: hidden;\n    transition: transform 0.25s ease;\n}\n\nbody.light_theme .news-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n}\n\n.news-card:hover {\n    transform: translateY(-4px);\n}\n\n.news-card-top-border {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 7px;\n}\n\n.news-card-top-border.purple {\n    background-color: #8B5CF6;\n}\n\n.news-card-top-border.green {\n    background-color: #10B981;\n}\n\n.news-card-top-border.gold {\n    background-color: #F59E0B;\n}\n\n.news-category-badge {\n    display: inline-block;\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 13px;\n    font-weight: 700;\n    margin-bottom: 12px;\n}\n\n.news-category-badge.purple {\n    background-color: #F5F3FF;\n    color: #8B5CF6;\n}\n\n.news-category-badge.green {\n    background-color: #ECFDF5;\n    display: inline-block;\n    color: #10B981;\n}\n\n.news-category-badge.gold {\n    background-color: #FFFBEB;\n    color: #F59E0B;\n}\n\n.news-card h3 {\n    font-size: 15px;\n    font-weight: 700;\n    color: #f8f8f8;\n    margin: 0 0 12px 0;\n    line-height: 1.4;\n}\n\nbody.light_theme .news-card h3 {\n    color: #111827;\n}\n\n.news-date {\n    font-size: 12px;\n    color: #9CA3AF;\n}\n\n\n\n@media (max-width: 1500px) {\n\n    .token-container {\n        max-width: 95%;\n    }\n\n    .diamond-col.is-bottom {\n        padding-top: 95px;\n    }\n\n    .token-hero-title {\n        font-size: 48px;\n    }\n\n}\n\n\n@media (max-width: 1200px) {\n\n\n\n    .token-hero-title {\n        font-size: 38px;\n    }\n\n    .token-hero-right {\n        width: 400px;\n    }\n\n    .token-hero {\n        padding: 40px 0px;\n    }\n\n    /* .diamond-flow-container {\n        grid-template-columns: repeat(3, 1fr);\n        height: auto;\n        gap: 30px;\n    } */\n\n    .diamond-col.is-bottom {\n        padding-top: 120px;\n    }\n\n    .section-header-center h2 {\n        font-size: 36px;\n    }\n\n    .chart-bar {\n        width: 26px;\n    }\n\n    .bottom-cards-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .news-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 991px) {\n\n    .token-hero-right {\n        width: 340px;\n    }\n\n    .diamond-text-content h3 {\n        color: #fff;\n    }\n\n    body.light_theme .diamond-text-content h3 {\n        color: #111827;\n    }\n\n    .token-hero-title {\n        font-size: 32px;\n    }\n\n    .token-hero-desc {\n        max-width: 100%;\n        font-size: 15px;\n        margin: 0 0 22px 0;\n    }\n\n    .token-hero-btns a {\n        font-size: 14px;\n        padding: 10px 22px;\n    }\n\n    .diamond-flow-container {\n        grid-template-columns: repeat(3, 1fr);\n    }\n\n    .token-hero {\n        padding: 20px 0px 40px;\n    }\n\n    .tokenlist_value {\n        margin-bottom: 40px;\n    }\n\n    .section-header-center h2 {\n        font-size: 32px;\n    }\n\n    .why-agce-bg-vector {\n        display: none;\n    }\n\n    .diamond-col.is-bottom {\n        flex-direction: column-reverse;\n        padding-top: 0px;\n        justify-content: start;\n    }\n\n    .diamond-flow-container {\n        height: 100%;\n    }\n\n    .section-header-center {\n        margin-bottom: 10px;\n    }\n\n    .why-agce-section {\n        margin-bottom: 10px;\n    }\n\n    .token-cards-grid {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .tokenomics-grid-section {\n        margin-bottom: 40px;\n    }\n\n\n}\n\n@media (max-width: 767px) {\n\n\n    .token-hero {\n        padding: 10px 0px 20px;\n        flex-direction: column;\n        text-align: center;\n        gap: 20px;\n    }\n\n    .token-hero-btns {\n        justify-content: center;\n        margin-bottom: 20px;\n    }\n\n    .token-hero-title {\n        font-size: 26px;\n        margin-bottom: 12px;\n    }\n\n    .token-hero-desc {\n        font-size: 14px;\n        margin: 0px 0 15px 0;\n    }\n\n    .token-metrics-bar {\n        grid-template-columns: repeat(3, 1fr);\n        gap: 15px;\n    }\n\n    .tokenlist_value {\n        margin-bottom: 30px;\n    }\n\n    .section-header-center h2 {\n        font-size: 24px;\n    }\n\n\n}\n\n@media (max-width: 580px) {\n\n    .token-metrics-bar {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .diamond-flow-container {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .diamond-col.is-bottom {\n        height: 180px;\n    }\n\n    .price-main {\n        font-size: 24px;\n    }\n\n    .token-card-title {\n        font-size: 18px;\n    }\n\n    .token-card {\n        padding: 20px;\n    }\n\n    .benefit-icon-badge {\n        width: 32px;\n        min-width: 32px;\n        height: 32px;\n    }\n\n    .news-section h2.token-card-title {\n        font-size: 22px !important;\n        margin-bottom: 12px !important;\n    }\n\n    .news-section {\n        padding: 30px 0px;\n    }\n\n}\n\n/* fix kero - Dark theme support for Token page */\nhtml[data-theme=\"dark\"] .token-page,\nbody:not(.light_theme) .token-page {\n    background-color: #0b0e14;\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .token-hero-title,\nhtml[data-theme=\"dark\"] .section-header-center h2,\nhtml[data-theme=\"dark\"] .token-card-title,\nhtml[data-theme=\"dark\"] .metric-value,\nhtml[data-theme=\"dark\"] .contract-code,\nhtml[data-theme=\"dark\"] .use-case-title,\nhtml[data-theme=\"dark\"] .benefit-title,\nbody:not(.light_theme) .token-hero-title,\nbody:not(.light_theme) .section-header-center h2,\nbody:not(.light_theme) .token-card-title,\nbody:not(.light_theme) .metric-value,\nbody:not(.light_theme) .contract-code,\nbody:not(.light_theme) .use-case-title,\nbody:not(.light_theme) .benefit-title {\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .token-hero-desc,\nhtml[data-theme=\"dark\"] .section-header-center p,\nhtml[data-theme=\"dark\"] .token-card-desc,\nhtml[data-theme=\"dark\"] .metric-item h4,\nhtml[data-theme=\"dark\"] .metric-item p,\nhtml[data-theme=\"dark\"] .use-case-desc,\nhtml[data-theme=\"dark\"] .contract-address-box,\nbody:not(.light_theme) .token-hero-desc,\nbody:not(.light_theme) .section-header-center p,\nbody:not(.light_theme) .token-card-desc,\nbody:not(.light_theme) .metric-item h4,\nbody:not(.light_theme) .metric-item p,\nbody:not(.light_theme) .use-case-desc,\nbody:not(.light_theme) .contract-address-box {\n    color: #a0aab5;\n}\n\n\nhtml[data-theme=\"dark\"] .token-card,\nhtml[data-theme=\"dark\"] .use-case-card,\nhtml[data-theme=\"dark\"] .benefit-card,\nbody:not(.light_theme) .token-card,\nbody:not(.light_theme) .use-case-card,\nbody:not(.light_theme) .benefit-card {\n    background-color: #181a20;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n    border: 1px solid #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .use-cases-section,\nhtml[data-theme=\"dark\"] .news-section,\nbody:not(.light_theme) .use-cases-section,\nbody:not(.light_theme) .news-section {\n    background-color: #0b0e14;\n}\n\nhtml[data-theme=\"dark\"] .whitepaperbtn,\nbody:not(.light_theme) .whitepaperbtn {\n    background-color: #2b3139;\n    color: #ffffff;\n    border-color: #3b424a;\n}\n\nhtml[data-theme=\"dark\"] .whitepaperbtn:hover,\nbody:not(.light_theme) .whitepaperbtn:hover {\n    background-color: #3b424a;\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .contract-address-box,\nbody:not(.light_theme) .contract-address-box {\n    background-color: #181a20;\n    border-color: #2b3139;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
